import { useEffect, useRef } from 'react';
import { errorCounter, SERVICE_NAME } from '../../observability/component-error-counter';
function isRecord(value) {
    return typeof value === 'object' && value !== null;
}
function unavailable(unavailableReason) {
    return {
        termsText: null,
        isTermsAvailable: false,
        unavailableReason,
    };
}
function resolveTermsSource(product) {
    if (product === null || product === undefined) {
        return unavailable('missing_product');
    }
    if (!isRecord(product)) {
        return unavailable('missing_term_version');
    }
    const terms = product.terms;
    if (!isRecord(terms)) {
        return unavailable('missing_term_version');
    }
    const termVersion = terms.termVersion;
    if (!isRecord(termVersion)) {
        return unavailable('missing_term_version');
    }
    if (termVersion.sourceType !== 'TEXT') {
        return unavailable('unsupported_source_type');
    }
    const sourceValue = termVersion.sourceValue;
    if (typeof sourceValue !== 'string' || sourceValue.trim().length === 0) {
        return unavailable('empty_source_value');
    }
    return {
        termsText: sourceValue,
        isTermsAvailable: true,
        unavailableReason: null,
    };
}
export function useProductTermsSource({ product, productSlug, }) {
    const reportedUnavailableSources = useRef(new Set());
    const termsSource = resolveTermsSource(product);
    useEffect(() => {
        if (termsSource.isTermsAvailable) {
            reportedUnavailableSources.current.clear();
            return;
        }
        const reportKey = `${productSlug}:${termsSource.unavailableReason}`;
        if (reportedUnavailableSources.current.has(reportKey)) {
            return;
        }
        reportedUnavailableSources.current.add(reportKey);
        errorCounter.add(1, {
            service: SERVICE_NAME,
            error: termsSource.unavailableReason,
            operation: 'billing.product.terms_source.unavailable',
            productSlug,
        });
    }, [productSlug, termsSource.isTermsAvailable, termsSource.unavailableReason]);
    return termsSource;
}
